import { useStore } from "src/stores/Store";
import tw from "src/utils/tw";

interface Props {
  alwaysShow?: boolean;
  className?: string;
}

export function ComingSoon(props: Props) {
  const store = useStore();

  if (store.user.isSalesOrAbove && !props.alwaysShow) {
    return null;
  }

  return (
    <div
      className={tw(
        "inline-block",
        "bg-main",
        "text-white",
        "text-xs",
        "font-bold",
        "uppercase",
        "px-2",
        "py-1",
        "rounded",
        "mx-2",
        props.className
      )}
    >
      Coming Soon
    </div>
  );
}
